import EventBus from '../EventBus';

export const ToggleMenuMixin = {
    methods: {
        toggleMenu() {
            EventBus.$emit('TOGGLE_MENU');
            window.scrollTo(0,0);
        }
    }
}